const values = [
  "banner02_blue",
  "banner02_brown",
  "banner02_gold",
  "banner02_green",
  "banner02_light_red",
  "banner02_orange",
  "banner02_purple",
  "banner02_red",
];
export default values;
